/* ═══════════════════════════════════════════════════════════
   js/mortgage-calc.js — Ипотечный калькулятор БРОНИДОМ v15
   Подключается на: index, mortgage, cabinet (где нужен)
   Guard: если #calcPrice не найден — выходим
   ═══════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  // Guard: если калькулятора нет на странице — выходим
  const priceEl = document.getElementById('calcPrice');
  if (!priceEl) return;

  function fmt(n) {
    return Math.round(n).toLocaleString('ru');
  }

  function calcMortgage() {
    const price = +document.getElementById('calcPrice').value || 0;
    const down  = +document.getElementById('calcDown').value || 0;
    const rate  = +document.getElementById('calcRate').value || 0;
    const years = +document.getElementById('calcYears').value || 1;
    const loan  = price - down;

    if (loan <= 0) {
      ['calcMonthly', 'calcTotal', 'calcOverpay'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.textContent = '–';
      });
      return;
    }

    const r = rate / 100 / 12;
    const n = years * 12;
    let monthly;
    if (r === 0) monthly = loan / n;
    else monthly = loan * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

    const total = monthly * n;
    const overpay = total - loan;

    const setEl = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    setEl('calcMonthly', fmt(monthly) + ' ₽');
    setEl('calcTotal', fmt(total) + ' ₽');
    setEl('calcOverpay', fmt(overpay) + ' ₽');

    // Sync range sliders if present
    const syncVal = (id, val) => { const el = document.getElementById(id); if (el) el.value = val; };
    syncVal('calcPriceR', price);
    syncVal('calcDownR', down);
    syncVal('calcRateR', rate);
    syncVal('calcYearsR', years);
  }

  function syncRange(inputId, rangeId) {
    const inp = document.getElementById(inputId);
    const rng = document.getElementById(rangeId);
    if (inp && rng) inp.value = rng.value;
  }

  // Expose globally for onclick handlers in HTML
  window.calcMortgage = calcMortgage;
  window.syncRange = syncRange;

  // Auto-calculate on input changes
  ['calcPrice', 'calcDown', 'calcRate', 'calcYears'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('input', calcMortgage);
  });

  // Sync range → input
  ['calcPriceR', 'calcDownR', 'calcRateR', 'calcYearsR'].forEach(rangeId => {
    const rng = document.getElementById(rangeId);
    if (rng) {
      const inputId = rangeId.replace('R', '');
      rng.addEventListener('input', () => {
        const inp = document.getElementById(inputId);
        if (inp) inp.value = rng.value;
        calcMortgage();
      });
    }
  });

  // Initial calculation
  calcMortgage();

})();
